var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.5C17 0.223858 17.2239 0 17.5 0H23.5C23.7761 0 24 0.223858 24 0.5V6C24 6.27614 23.7761 6.5 23.5 6.5C23.2239 6.5 23 6.27614 23 6V1.70711L12.8536 11.8536C12.6583 12.0488 12.3417 12.0488 12.1465 11.8536L9.47982 9.18692L0.832187 16.8737C0.625796 17.0572 0.30976 17.0386 0.126301 16.8322C-0.0571583 16.6258 -0.038568 16.3098 0.167823 16.1263L9.16782 8.1263C9.36569 7.95041 9.66636 7.95925 9.85356 8.14645L12.5 10.7929L22.2929 1H17.5C17.2239 1 17 0.776142 17 0.5ZM0 19C0 18.4477 0.447715 18 1 18H10C10.5523 18 11 18.4477 11 19V23C11 23.5523 10.5523 24 10 24H1C0.447715 24 0 23.5523 0 23V19ZM1 19V23H10V19H1ZM14 13C13.4477 13 13 13.4477 13 14V23C13 23.5523 13.4477 24 14 24H23C23.5523 24 24 23.5523 24 23V14C24 13.4477 23.5523 13 23 13H14ZM14 23V14H23V23H14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.f4f5af39.svg";
export { ForwardRef as ReactComponent };